"use client";

import { useMountEffect } from "@opensea/ui-kit/hooks";
import { AccountActions } from "../stores/accountStore";
export const useDisableAccountSync = () => {
  useMountEffect(_temp2);
};
function _temp() {
  AccountActions.setShouldSyncAccountState(true);
}
function _temp2() {
  AccountActions.setShouldSyncAccountState(false);
  return _temp;
}